export const NEW = 0;
export const PROCESSING = 1;
export const AWAITING = 2;
export const AVAILABLE = 5;
export const PENDING_DELETE = 7;
export const DELETED = 9;
